"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var __jsx = _react["default"].createElement;
var TimeBox = function TimeBox(_ref) {
  var numberOrText = _ref.numberOrText,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 70 : _ref$width,
    separator = _ref.separator;
  return __jsx(_Box["default"], {
    as: "span",
    sx: {
      width: width,
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  }, numberOrText !== null && numberOrText !== void 0 ? numberOrText : "", separator ? __jsx(_Box["default"], {
    as: "span",
    sx: {
      px: "s3"
    }
  }, separator) : "");
};
var _default = TimeBox;
exports["default"] = _default;